import React from 'react'

import { AdminHeader, Layout } from 'components'

import { MessagesEditor } from 'modules/Messages/containers'

const MessagesPage = () => (
  <Layout>
    <AdminHeader />
    <MessagesEditor />
  </Layout>
)

export default MessagesPage
